import _ from 'lodash';
// initial state
const state = () => ({})

// getters
const getters = {
    getStateSchedulingModule(state) {
        if(_.isEmpty(state)) {
            const newState = JSON.parse(localStorage.getItem('@datadrive:backoffice-scheduling'));
            if(newState !== null && newState !== undefined) {
                mutations.setStateSchedulingModule(state, newState);
                return newState;
            } else {
                return state;
            }
        } else {
            return state;
        }
    },
}

// actions
const actions = {}

// mutations
const mutations = {
    setStateSchedulingModule(state, payload) {
      for (var [key, value] of Object.entries(payload)) {
          state[key] = value;
      }

      localStorage.setItem('@datadrive:backoffice-scheduling', JSON.stringify(state));
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
